import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { Recurrence } from 'ish-core/models/recurrence/recurrence.model';
import { OrderRecurrenceComponent } from 'ish-shared/components/order/order-recurrence/order-recurrence.component';

@Component({
  selector: 'ish-basket-recurrence-summary',
  templateUrl: './basket-recurrence-summary.component.html',
  styleUrls: ['./basket-recurrence-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [OrderRecurrenceComponent, TranslateModule],
})
export class BasketRecurrenceSummaryComponent {
  readonly recurrence = input.required<Recurrence>();
}
